import { render } from "./UserBadge.vue?vue&type=template&id=29b3dfb4&scoped=true"
import script from "./UserBadge.vue?vue&type=script&lang=js"
export * from "./UserBadge.vue?vue&type=script&lang=js"

import "./UserBadge.vue?vue&type=style&index=0&id=29b3dfb4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b3dfb4"]])

export default __exports__